import React from "react";
import { getBrandLogo } from "src/common";
import { OfferTermsAndConditionsGetDto } from "src/common/api/apollo/types/types";
import { colors } from "src/theme";
import { Flex } from "../grid";
import { DownloadFileIcon } from "../icons";
import { Card } from "./card";
import { Text } from "../typography";
import styled from "@emotion/styled";

const FileRow = styled.a({
  display: 'flex',
  alignItems: 'center',
  gap: 12,
  padding: '12px 16px',
  borderRadius: 8,
  border: `1px solid ${colors.border5}`,
  textDecoration: 'none',
  cursor: 'pointer',
  transition: 'background 0.15s',
  '&:hover': {
    background: colors.background6,
  },
});

const LogoStyle = styled.img({
  maxWidth: '100%',
  height: 64,
  objectFit: 'contain',
  objectPosition: 'left',
});

interface TermsCardProps {
  termsAndConditions: OfferTermsAndConditionsGetDto;
  isModal?: boolean;
}

const TermsCard: React.FC<TermsCardProps> = ({ termsAndConditions, isModal }) => {
  return (
    <Card padding={16}>
      <Flex vertical gap={12}>
        {!isModal && (
          <Flex align="center" justify="space-between" gap={12}>
            <LogoStyle src={getBrandLogo(termsAndConditions.brandCode, termsAndConditions.brandLogo)} alt={termsAndConditions.brandName} />
            <Flex vertical align="flex-end" gap={8}>
              <Text type="xLarge" bold>{termsAndConditions.productName}</Text>
              <Text type="base">{termsAndConditions.brandName}</Text>
            </Flex>
          </Flex>
        )}
        <Flex vertical gap={8} style={{ marginTop: isModal ? 0 : 32 }}>
          {termsAndConditions.documents.map((doc) => (
            <FileRow key={doc.fileId} href={doc.src} target="_blank" rel="noopener noreferrer">
              <DownloadFileIcon width={20} height={20} color={colors.primary} />
              <Text type="base" color={colors.text1}>{doc.fileName}</Text>
            </FileRow>
          ))}
        </Flex>
      </Flex>
    </Card>
  );
};

export default TermsCard;
